// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76eea9ba","239":"73b31052","455":"aae5ba7e"}[chunkId] + ".chunk.js";
};